import { InjectionToken } from '@angular/core';
import { FaxService } from '../services/fax/fax.service';

export const FAX_SERVICE = new InjectionToken<FaxService>('FAX_SERVICE');
